import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
    Inject, 
	ViewRef
} 
from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTabChangeEvent, MatTabGroup, MatTab, MatTabHeader } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
// RXJS
import { BehaviorSubject, ReplaySubject } from 'rxjs';
//Service
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { DeNghiMuaHangService } from '../de-nghi-mua-hang-service/de-nghi-mua-hang.service';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { DeNghiMuaHang, DeNghiMuaHangCT } from '../de-nghi-mua-hang-model/de-nghi-mua-hang.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';

@Component({
	selector: 'm-xac-nhan-mua-hang',
	templateUrl: './xac-nhan-mua-hang.component.html',
	styleUrls: ['../de-nghi-mua-hang.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class XacNhanMuaHangComponent implements OnInit{

    /*Config Form */
    CONFIG: CommonConFig;

    displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHang',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHang',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoLuong',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'GhiChu',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'NccId',
            displayName: 'Mã NCC',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 9,
            name: 'TenNCC',
            displayName: 'Tên NCC',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 10,
            name: 'NgayGiaoDuKien',
            displayName: 'Ngày dự kiến có hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 11,
            name: 'GhiChuXacNhan',
            displayName: 'Ghi chú xác nhận',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'DonGia',
            displayName: 'ĐG',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'ThanhTien',
            displayName: 'Thành tiền',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 15,
            name: 'ThanhTienQuyDoi',
            displayName: 'Thành tiền quy đổi',
            alwaysChecked: false,
			isShow: true
		},
    ];

    /* Danh sách trạng thái */
	listState : any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */

	/* Danh sách trạng thái */
	listPB : any[] = [];
	PBUser: string = '';   					//Tên phòng ban của user
	/* ------------------------------------------------------------------ */

	/* Danh sách tiền tệ */
	currency_unit = [];
	selectedCurrency: string = '';
	/* ------------------------------------------------------------------ */
	
    /* Mat select search cho nhà cung cấp */
	listListNCC : any[] = [];
	selectListNCC : string = '';
	filteredListNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListNCCFilterCtrl: string = '';
	haveElementListNCC: boolean = false;
	arrayNCCForEachHH: any[] = [];
    /* ------------------------------------------------------------------ */
    
    /* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiMuaHang>(true, []);
    /* ------------------------------------------------------------------ */
    
    /* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
    /* ----------------------------------------------------------*/

	/* Extend field:  */
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 			    // Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                     // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;		    // Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAdded: number[] = []	        // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;       // Loading khi mở dialog
	canEdit: boolean = true;		    // Dialog có thể chỉnh sửa không?
	sumTT: number = 0;				    // Trường lưu tổng tiền
	disableXacNhan : boolean = true;
	category_path: string = 'PDNMH'     // path lấy tình trạng phím
	listTT: any = [];
	isVuotHanMuc: boolean = false;		// Vượt hạn mức hay không
	hanMucPB: string = '0';
	minDate: any;
    /* ------------------------------------------------------------------ */

    /* Các Sub form trên dialog:  */
	DeNghiMuaHangForm: FormGroup;				//Form phiếu đề nghị
	TienTeForm: FormGroup						//Form chọn đơn vị và tỷ giá
    TPDuyetMuaForm: FormGroup;					//Form TP duyệt mua
    /* ------------------------------------------------------------------ */

    /* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	deNghiMuaHangItem: DeNghiMuaHang;

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị:  */
    listChiTietMuaHang: DeNghiMuaHangCT[] = [];


    constructor(
		public dialogRef: MatDialogRef<XacNhanMuaHangComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private deNghiMuaHangService: DeNghiMuaHangService,
		private dungChungService: DungChungService,
		private DeNghiMuaHangFB: FormBuilder,
		private TienTeFB: FormBuilder,
        private TPDuyetGiaFB: FormBuilder,
        private TPDuyetMuaFB: FormBuilder,
		private GDDuyetFB: FormBuilder,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef
    ) { 
		this.dialogRef.disableClose = true;
    }

    /*---------------------------- LOAD DATA --------------------------------*/
    ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
        this.deNghiMuaHangItem = this.data.data;
        this.listTT = DeNghiMuaHang.optionsTinhTrang
		/*Load title of dialog */
		this.title = this.getTitle();
		this.minDate = new Date();
        /*Load all dropdown and create form */
        this.ListPB();
        this.ListState();
		this.ListNCC();
		this.getHanMucPhongBan();
		this.getCurrentUnit();
		this.createForm();

		/*Handel escape event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.OK.KeyCombine.keycode  && !this.disableXacNhan) {
				this.onSubmit();
			}
			this.changeDetectView();
        });
        
		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
    }
    /* -----------------------------------------------------------------------*/


    /*----------------- Create Form with appropriate sub forms ---------------*/
    createForm(){
		
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		
		/*Group các Form */
		this.DeNghiMuaHangForm = this.DeNghiMuaHangFB.group({
			SoPhieu: [this.deNghiMuaHangItem.SoPhieu],
			NgayLapPhieu: [this.deNghiMuaHangItem.NgayYeuCau],
			TenNguoiLap: [this.deNghiMuaHangItem.TenNguoiTao],
			TrangThai: [this.nameState],
			PBDeNghi: [this.PBUser],
			NganSachCon: [this.hanMucPB],
			LoaiPhieu: [this.deNghiMuaHangItem.LoaiPhieu],
			NgayCan: [this.deNghiMuaHangItem.NgayDeNghiCoHang],
			DienGiai: [this.deNghiMuaHangItem.DienGiaiLyDo]
		});

		/*Disable các trường dữ liệu không thay đổi */
		this.DeNghiMuaHangForm.controls["SoPhieu"].disable();
		this.DeNghiMuaHangForm.controls["NgayLapPhieu"].disable();
		this.DeNghiMuaHangForm.controls["TenNguoiLap"].disable();
		this.DeNghiMuaHangForm.controls["TrangThai"].disable();
        this.DeNghiMuaHangForm.controls["PBDeNghi"].disable();
        this.DeNghiMuaHangForm.controls["LoaiPhieu"].disable();
        this.DeNghiMuaHangForm.controls["NgayCan"].disable();
		this.DeNghiMuaHangForm.controls["DienGiai"].disable();
		this.DeNghiMuaHangForm.controls["NganSachCon"].disable();
        /*------------------------------------------------------------------*/
		
		let tmpObject = this.deNghiMuaHangItem.listPhieuDeNghiLsThaoTac.find(x => 
			x.LoaiThaoTac == DeNghiMuaHang.optionsTinhTrang[1].value
		)
        this.TPDuyetMuaForm = this.TPDuyetMuaFB.group({
            NguoiXacNhan: [tmpObject.TenNguoiThaoTac],
            NgayXacNhan: [this.getFormatDate(tmpObject.NgayThaoTac)],
            LyDo: [tmpObject.NoiDung]
        })
        this.TPDuyetMuaForm.disable();
		/*------------------------------------------------------------------*/
		
		this.TienTeForm = this.TienTeFB.group({
            TienTe: [this.selectedCurrency,Validators.required],
            TyGia: ['1', Validators.compose([Validators.required, 
													Validators.min(0.01),
													Validators.pattern(this.CONFIG.REGEX_FORMAT_QUANTITY)])],
        })

        this.listChiTietMuaHang = this.deNghiMuaHangItem.listChiTietMuaHang;
        this.listChiTietMuaHang.forEach(element =>{
            element.NgayGiaoDuKien = this.deNghiMuaHangItem.NgayDeNghiCoHang;
            if(element.DonGia == null || element.DonGia == undefined){
                element.DonGia = '0';
            }
        })
        this.listChiTietMuaHang = [...this.listChiTietMuaHang];
        this.changeDetectView();
	}
	getTitle(): string {
		return `Xác nhận đề nghị mua hàng`;
	}
    /* -----------------------------------------------------------------------*/


    /*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
    /* -----------------------------------------------------------------------*/


    /*------------------------- Hàm lấy danh sách-----------------------------*/
    async ListState(){
		let res = await this.dungChungService.listState(this.category_path).toPromise();
		if(res && res.status === 1){
			this.listState = res.data;
			this.checkState();
			this.changeDetectView();
		}else{
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.deNghiMuaHangItem.TinhTrang){
				this.nameState = element.Description;
				if(this.DeNghiMuaHangForm != null)
					this.DeNghiMuaHangForm.controls["TrangThai"].setValue(this.nameState);
			}	
		});
	}

	async getCurrentUnit(){
		let res = await this.dungChungService.getDSTienTe().toPromise();
		if(res && res.status === 1){
			
			this.currency_unit = res.data;
			this.selectedCurrency = this.currency_unit[0].Id;
			this.TienTeForm.controls["TienTe"].setValue(this.selectedCurrency);
			this.updateTienTeRecord();
			this.changeDetectView();
		}else{
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

    async ListPB(){
		let res = await this.dungChungService.listPB().toPromise();
		if(res && res.status === 1){
			this.listPB = res.data;
			var phongban = '';
			this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

			if(this.deNghiMuaHangItem.Id > 0){
				this.listPB.forEach(element => {
					if(element.Id_PB == +this.deNghiMuaHangItem.PhongBanId){
						this.PBUser = element.TenPB;
					}
				})
			}
			else{
				this.listPB.forEach(element => {
					if(element.Id_PB == +phongban){
						this.PBUser = element.TenPB;
					}
				})
			}
			this.DeNghiMuaHangForm.controls["PBDeNghi"].setValue(this.PBUser)
			this.changeDetect.detectChanges();
		}else{
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	getHanMucPhongBan(){
		var phongban = '';
		if(this.deNghiMuaHangItem.Id > 0){
			phongban = this.deNghiMuaHangItem.PhongBanId.toString();
		}
		else{
			this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
		}
		
		this.dungChungService.getHanMucPhongBan(+phongban).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.hanMucPB = res.data;
				if(this.hanMucPB == null || this.hanMucPB == '')
					this.hanMucPB = '0'
				this.DeNghiMuaHangForm.controls["NganSachCon"].setValue(this.f_currency_V2((this.hanMucPB)));
				(+this.sumTT > +this.hanMucPB) ? this.isVuotHanMuc = true : this.isVuotHanMuc = false;
				this.changeLoaiPhieu();
			};
		});
	}
    changeLoaiPhieu(){
		if(this.DeNghiMuaHangForm.controls["LoaiPhieu"].value == DeNghiMuaHang.optionsLoaiPhieu[0].value){
			this.DeNghiMuaHangForm.controls["NganSachCon"].setValue(this.f_currency_V2((this.hanMucPB)));
		}
		else if(this.DeNghiMuaHangForm.controls["LoaiPhieu"].value == DeNghiMuaHang.optionsLoaiPhieu[1].value ||
					this.DeNghiMuaHangForm.controls["LoaiPhieu"].value == DeNghiMuaHang.optionsLoaiPhieu[2].value){
						this.DeNghiMuaHangForm.controls["NganSachCon"].setValue('0');
		}
	}

    async ListNCC(){
		let listIDHH:number[] = [];
		this.deNghiMuaHangItem.listChiTietMuaHang.forEach(element =>{
			listIDHH.push(element.HangHoaId);
		})
		let res = await this.deNghiMuaHangService.listQLGMNCC(listIDHH).toPromise();
		if(res && res.status === 1){
			this.listListNCC = res.data;
			this.filteredListNCC.next(this.listListNCC.slice());
				this.listChiTietMuaHang.forEach(element =>{
					let filterTmp = new ReplaySubject<any[]>(1)
					filterTmp.next(this.listListNCC.filter(ts => 
							ts.HangHoaId == element.HangHoaId && ts.SoLuongTu <=  Number(element.SoLuong))
					);
					this.arrayNCCForEachHH.push(filterTmp);
				})
			this.changeDetectView();
		}else{
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	filterListNCC(item:any) {
		if (!this.listListNCC) {
			return;
		}
		// get the search keyword
		let search = this.ListNCCFilterCtrl;
		let index = this.listChiTietMuaHang.indexOf(item)

		if (!search) {
			this.arrayNCCForEachHH[index].next(
				this.listListNCC.filter(ts => 
					ts.HangHoaId == item.HangHoaId)
			);
			return;
		} else {
			search = search.toLowerCase();
		}
		
		if(index > -1){
			this.arrayNCCForEachHH[index].next(
				this.listListNCC.filter(ts => 
					ts.HangHoaId == item.HangHoaId).filter(ts => 
						ts.MaNCC.toLowerCase().indexOf(search) > -1)
			);
		}
		this.changeDetect.detectChanges();
	}
	changeValueAfterSelectNCC(item,index){
		this.listListNCC.forEach(element =>{
			if(element.NccId == item.NccId && element.HangHoaId == item.HangHoaId){
				this.listChiTietMuaHang[index].DonGia = element.GiaMua
				this.listChiTietMuaHang[index].ThanhTien = '' + (Number(item.DonGia) * Number(item.SoLuong))
				this.listChiTietMuaHang[index].MaNCC = element.MaNCC
				this.listChiTietMuaHang[index].TenNCC = element.TenNCC
			}
		})
		this.updateThanhTienQuyDoi();
		this.changeDetect.detectChanges();
	}
    /* -----------------------------------------------------------------------*/


    /*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
    ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == '.'){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == '.'){
					count += 1;
				}
			}
		}
		;
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
    }
    ValidateChangeNumberEvent(columnName:string, item:any, event: any) {
		var count = 0;
		for(let i = 0; i < event.target.value.length; i++){
			if(event.target.value[i] == '.'){
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		if(typeof(item) === "string"){
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    changeValueOfForm(controlName: string, event: any){
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = this.DeNghiMuaHangForm.controls[controlName].value.replace(/,/g, "");
			this.DeNghiMuaHangForm.controls[controlName].setValue(
					this.f_currency_V2(tmpValue)
			);
			
			(+this.sumTT > tmpValue) ? this.isVuotHanMuc = true : this.isVuotHanMuc = false;
		}
		else{
			this.DeNghiMuaHangForm.controls[controlName].setValue(event.target.value);
		}
	}
	changeValueTienTeForm(controlName: string, event: any){
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = this.TienTeForm.controls[controlName].value.replace(/,/g, "");
			this.TienTeForm.controls[controlName].setValue(
					this.f_currency_V2(tmpValue)
			);
		}
		else{
			this.TienTeForm.controls[controlName].setValue(event.target.value);
		}
    }
    changeValueOfColumn(columnName:string, item:any, event: any, afterUpdate: boolean){
		if(columnName == 'DonGia'){
			if(afterUpdate)
				this.listChiTietMuaHang[this.listChiTietMuaHang.indexOf(item)].DonGia = this.formatNumber(item.DonGia);
			else if(!afterUpdate){
				
				this.listChiTietMuaHang[this.listChiTietMuaHang.indexOf(item)].DonGia = event.target.value.trim();
				if(this.ValidateChangeNumberEvent(columnName,item,event)){
					this.listChiTietMuaHang[this.listChiTietMuaHang.indexOf(item)].ThanhTien = '' + (Number(item.DonGia.replace(/,/g, "")) * Number(item.SoLuong))
					this.updateThanhTienQuyDoi();
					this.changeDetectView();
				}
			}
		}
	}
	checkPositiveNumbers(event){
		FunctionPublic.checkPositiveNumbers(event);
	}
	changeInputCurrency(event, columnName, formGroup){
		var regex = this.CONFIG.REGEX_EXCEPT_ALPHABET_CHARACTER;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChanged(event);
			if(data){
				formGroup.controls[columnName].setValue(data);
				this.changeDetect.detectChanges();
			}
		}
	}
	updateThanhTienQuyDoi(){
		let tygia = +(this.TienTeForm.controls['TyGia'].value.replace(/,/g, ""));
		if(!tygia){
			tygia = 1;
			this.TienTeForm.controls['TyGia'].setValue('1');
		}
		let buttonDisable = false;
		this.sumTT = 0;
		this.listChiTietMuaHang.forEach(element =>{
			element.Tygia = tygia.toString();
			element.ThanhTienQuyDoi = '' + (Number(element.ThanhTien) * tygia)
			this.sumTT += Number(element.ThanhTienQuyDoi)
			if(element.NccId == null || element.NccId == undefined || 
				element.ThanhTienQuyDoi == null || element.ThanhTienQuyDoi == '0'){
					buttonDisable = true;
			}
		})
		buttonDisable ? this.disableXacNhan = true : this.disableXacNhan = false;
		(+this.sumTT > +this.DeNghiMuaHangForm.controls['NganSachCon'].value.replace(/,/g, "")) ? this.isVuotHanMuc = true : this.isVuotHanMuc = false;

		this.listChiTietMuaHang = [...this.listChiTietMuaHang];
		this.changeDetectView();
	}
	updateTienTeRecord(){
		if(this.TienTeForm.controls['TienTe'].value != ''){
			let currency = this.currency_unit.find(x => x.Id == +this.TienTeForm.controls['TienTe'].value);
			if(currency != null){
				this.listChiTietMuaHang.forEach(element =>{
					element.TienTe_id = currency.Id
					element.TienTe_Ten = currency.Ten
				})
				this.listChiTietMuaHang = [...this.listChiTietMuaHang];
				this.changeDetectView();
			}
		}
	}
    /* -----------------------------------------------------------------------*/


    /*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
    getFormatDate(v: string = '') {
        if (v != null && v!= undefined && v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
    /* -----------------------------------------------------------------------*/


    /*---------------------------- Thao tác trên form ------------------------*/
    changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
    }
    back(){
		this.dialogRef.close({ 
            isChange: this.isChange,		//Dữ liệu có thay đổi hay không?
            dataAdd : this.saveAdded 	    //highlight ID
	    });
	}
    onSubmit() {

		for(let i = 0; i< this.listChiTietMuaHang.length; i++){
			if(this.listChiTietMuaHang[i].NccId == null || this.listChiTietMuaHang[i].NccId == 0
				|| this.listChiTietMuaHang[i].NgayGiaoDuKien == ''
				|| this.listChiTietMuaHang[i].DonGia == ''){
					this.layoutUtilsService.showErorr('Nhập đầy đủ thông tin xác nhận hàng hóa - ' + this.listChiTietMuaHang[i].MaHang);
					return null;
				}
		}

        const dialogRef = this.layoutUtilsService.POP02(this.deNghiMuaHangItem.SoPhieu);
        dialogRef.afterClosed().subscribe(res => {
            if (!res) {
                return;
			}
			
            this.listChiTietMuaHang.forEach(element =>{
                element.NgayGiaoDuKien = moment(new Date(element.NgayGiaoDuKien)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
            })
            this.deNghiMuaHangItem.listChiTietMuaHang = this.listChiTietMuaHang;
            this.deNghiMuaHangItem.TinhTrang = DeNghiMuaHang.optionsTinhTrang[2].value;
    
            this.deNghiMuaHangService.xacNhanDeNghiMuaHang(this.deNghiMuaHangItem).subscribe(res => {
                if (res.status == 1) {		
    
                    const message = `Xác nhận phiếu đề nghị mua hàng thành công`;
                    this.layoutUtilsService.showInfo(message);
                    this.saveAdded = []
                    this.saveAdded.push(this.deNghiMuaHangItem.Id);
                    this.isChange = true;

                    this.back();
                }
                else {
                    this.layoutUtilsService.showErorr(res.error.message);
                }
            });
        });
	}
    /* -----------------------------------------------------------------------*/
}